import styled from 'styled-components';
import { Input } from '@bynder/design-system';

export const StyledInput = styled(Input)`
    max-width: 138px;
`;
